import styled from "@emotion/styled";

const CheckboxBox = styled.span`
  label: CheckboxBox;
  --checkbox-border: var(--color-gray, #aaa7a0);
  --checkbox-border-strong: var(--color-charcoal-80, rgba(33, 33, 33, 0.8));
  --checkbox-fill: var(--color-charcoal, #212121);
  --checkbox-tick: var(--color-white, #fff);
  --checkbox-focus-ring: var(--color-gray-light, #e1ded4);

  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-sizing: border-box;
  width: var(--checkbox-size, 18px);
  height: var(--checkbox-size, 18px);
  border-radius: 4px;
  border: 1px solid var(--checkbox-border);
  background: var(--color-white, #fff);
  transition:
    background-color 120ms ease,
    border-color 120ms ease,
    box-shadow 120ms ease;

  &[data-checked="true"] {
    background: var(--checkbox-fill);
    border-color: var(--checkbox-fill);
  }

  svg {
    width: 68%;
    height: 68%;
    display: block;
    overflow: visible;
    opacity: 0;
    transition: opacity 90ms ease;
  }

  &[data-checked="true"] svg {
    opacity: 1;
  }

  path {
    fill: none;
    stroke: var(--checkbox-tick);
    stroke-width: 2.4;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  *:hover > &,
  [data-focused] > & {
    border-color: var(--checkbox-border-strong);
  }

  [data-focus-visible] > & {
    border-color: var(--checkbox-border-strong);
    box-shadow: 0 0 0 3px var(--checkbox-focus-ring);
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;

    svg {
      transition: none;
    }
  }
`;

export interface CheckboxVisualProps {
  isSelected: boolean;
}

export function CheckboxVisual({ isSelected }: CheckboxVisualProps) {
  return (
    <CheckboxBox data-checked={isSelected ? "true" : "false"}>
      <svg viewBox="0 0 16 16" aria-hidden>
        <path d="M3.2 8.4 L6.3 11.4 L12.8 4.7" />
      </svg>
    </CheckboxBox>
  );
}
